import $ from 'jquery'

export default () => {
    const nodeSelectors = {
        container: '[js-big-video="container"]',
        video: '[js-big-video="video"]',
        videoCover: '[js-big-video="cover"]',
        playBtn: '[js-big-video="play"]',
        soundBtn: '[js-big-video="sound"]',
    }

    function init() {
        if (!$(nodeSelectors.video).length) {
            return
        }

        initSection()
    }

    function initSection() {
        const videosSections = document.querySelectorAll(nodeSelectors.container)
        // setSectionsHeight(videosSections)

        videosSections.forEach(function (section, index){
            let video = section.querySelector(nodeSelectors.video)
            let playVideoBtn = section.querySelector(nodeSelectors.playBtn)
            // let soundVideoBtn = section.querySelector(nodeSelectors.soundBtn)

            playVideoBtn.addEventListener('click',  () => {
                if( video.paused ) {
                    video.play()
                    playVideoBtn.classList.remove('paused')
                    $(nodeSelectors.videoCover).fadeOut();
                    $(section).find('.video-info').addClass('hidden');
                    $(section).find('.play-icon').css('display', 'none');
                    $(section).find('.video-overlay').css('display', 'none');
                    
                } else {
                    video.pause()
                    playVideoBtn.classList.add('paused')
                    $(section).find('.video-info').removeClass('hidden');
                    $(section).find('.play-icon').css('display', 'flex');
                    $(section).find('.video-overlay').css('display', 'block');
                    $(nodeSelectors.videoCover).fadeIn();
                }
            })

            // soundVideoBtn.addEventListener('click',  () => {
            //     if( video.muted ) {
            //         video.muted = false
            //         soundVideoBtn.classList.add('unmuted')
            //     } else {
            //         video.muted = true
            //         soundVideoBtn.classList.remove('unmuted')
            //     }
            // })

            // video.onloadeddata = function() {
            //     // This should fire after src is replaced. Desk to mob video or mob to desk.
            //     playVideoBtn.classList.remove('paused')
            //     $(section).find('.big-video__image').addClass('hide')
            // };
        })

        // addEventListener("resize", (event) => {
        //     setSectionsHeight(videosSections)
        // });
    }

    // function setSectionsHeight(videosSections) {
    //     if( videosSections ) {
    //         let siteHeaderHeight = $('#main-header').outerHeight()
    //         let siteHeaderGroupHeight = $('.shopify-section-group-header-group').outerHeight()
    //         videosSections.forEach(function (section, index){
    //             $(section).height($(window).height() - (siteHeaderHeight + siteHeaderGroupHeight))
    //         })
    //     }
    // }

    return Object.freeze({
        init
    })
}